import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { Undefinable } from '@symfa-inc/providence-types';
import { SelectValue } from 'antd/es/select';
import { arrsToSelectableObject } from '@core/utils/methods';
import {
  AccountingBrowseFilter,
  AdminDropdownValuesData,
  ConfigureFilterProps,
  RangePickerValues,
} from '@models/interfaces';
import { Autocomplete, RangePicker } from '@shared/modules';
import { DDVSelectors, SOFToolSelectors } from '@store/selectors';

export const Filters: FC<ConfigureFilterProps<AccountingBrowseFilter>> = ({
  value,
  onChanges,
}: ConfigureFilterProps<AccountingBrowseFilter>) => {
  const dropdownValues = useSelector(DDVSelectors.getDDValues);
  const filtersOptions = useSelector(SOFToolSelectors.browseFilters);

  return (
    <>
      <Autocomplete
        id="FALocationNumber"
        key="FALocationNumber"
        label="FA Location Number"
        options={filtersOptions?.FALocationNumbers || []}
        elementProps={{
          allowClear: true,
          value: value.FALocationNumber,
          onChange: (e: SelectValue): void =>
            onChanges({ FALocationNumber: e as string }),
        }}
      />
      <Autocomplete
        id="projectWorkTypeId"
        key="projectWorkTypeId"
        label="Project Work Type"
        options={arrsToSelectableObject<AdminDropdownValuesData>(
          dropdownValues.ProjectWorkType,
          'id',
          'value',
        )}
        elementProps={{
          allowClear: true,
          value: value.projectWorkTypeId,
          onChange: (e: SelectValue): void =>
            onChanges({ projectWorkTypeId: e as string }),
        }}
      />
      <Autocomplete
        id="PACEProjectNumber"
        key="PACEProjectNumber"
        label="PACE Project Number"
        options={filtersOptions?.PACEProjectNumbers || []}
        elementProps={{
          allowClear: true,
          value: value.PACEProjectNumber,
          onChange: (e: SelectValue): void =>
            onChanges({ PACEProjectNumber: e as string }),
        }}
      />
      <Autocomplete
        id="IWMJobNumber"
        key="IWMJobNumber"
        label="IWM Job Number"
        options={filtersOptions?.IWMJobNumbers || []}
        elementProps={{
          allowClear: true,
          value: value.IWMJobNumber,
          onChange: (e: SelectValue): void =>
            onChanges({ IWMJobNumber: e as string }),
        }}
      />
      <RangePicker
        id="RE020ActualDate"
        key="RE020ActualDate"
        label="RE020 Actual Date"
        formItemProps={{ className: 'aligned-form-item' }}
        value={value.RE020ActualDate}
        onChange={(date: Undefinable<RangePickerValues>): void =>
          onChanges({ RE020ActualDate: date })
        }
      />
    </>
  );
};
